import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Restricted from "src/app/Restricted";
import PATHS, { url } from "src/consts/urlPaths";
import { ALLOWED_ROLES } from "src/services/auth";

const ProjectsLink = ({ children, item, className }) => (
  <Restricted allowedRoles={ALLOWED_ROLES.PROJECTS}>
    <Link
      id="projects-nav-link"
      to={url(PATHS.PROJECTS)}
      aria-label={item.name}
      className={className}
    >
      {children}
    </Link>
  </Restricted>
);
ProjectsLink.propTypes = {
  item: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default ProjectsLink;
